module.exports = __webpack_public_path__ + "img/coque-on.135f4b86.svg";